<div class="table-container">
  <table class="table">
    <thead>
      <tr>
        <th *ngFor="let col of columns; trackBy: trackByFn" (click)="toggleSort(col)" style="cursor: pointer">
          {{ col.headerText | translate }}
          <span *ngIf="sortColumn === col">
            <span *ngIf="sortDirection === 'asc'">&#9650;</span>
            <span *ngIf="sortDirection === 'desc'">&#9660;</span>
          </span>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngIf="paginatedData.length === 0">
        <td colspan="{{ columns.length }}">Aucune donnée disponible</td>
      </tr>
      <tr *ngFor="let data of paginatedData; trackBy: trackByFn">
        <td *ngFor="let col of columns; trackBy: trackByFn">
          <ng-container *ngIf="col.accessor; else fieldTemplate">
            <ng-container *ngIf="isPercentage(col)">{{ col.accessor(data) | number: '1.0-2' }}%</ng-container>
            <ng-container *ngIf="!isPercentage(col)">{{ col.accessor(data) }}</ng-container>
          </ng-container>
          <ng-template #fieldTemplate>
            <ng-container *ngIf="isPercentage(col)">{{ data[col.field] | number: '1.0-2' }}%</ng-container>
            <ng-container *ngIf="!isPercentage(col)">{{ data[col.field] }}</ng-container>
          </ng-template>
        </td>
      </tr>
    </tbody>
  </table>

  <div class="pagination-controls">
    <button (click)="prevPage()" [disabled]="currentPage === 1">Précédent</button>
    <span>Page {{ currentPage }} / {{ totalPages }}</span>
    <button (click)="nextPage()" [disabled]="currentPage === totalPages">Suivant</button>
  </div>
</div>
